import React, { Fragment } from 'react';

import { Helmet } from 'react-helmet';

import Navbar from '../components/navbar';
import Hero from '../components/hero';
import PainPoints from '../components/pain-points';
import NotificationServiceOverview from '../components/notification-service-overview';
import KeyBenefits from '../components/key-benefits';
import CTA from '../components/cta';
import Stepss from '../components/stepss';
import DocumentationServiceOverview from '../components/documentation-service-overview';
import Testimonial from '../components/testimonial';
import Contact from '../components/contact';
import Footer from '../components/footer';
import './home.css';

const Home = () => {
  return (
    <div className='home-container'>
      <Helmet>
        <title>Visa Slot</title>
        <meta property='og:title' content='Visa Slot' />
      </Helmet>
      <Navbar />
      <Hero rootClassName='heroroot-class-name' />
      <PainPoints rootClassName='pain-pointsroot-class-name1' />
      <NotificationServiceOverview rootClassName='notification-service-overviewroot-class-name1' />
      <KeyBenefits rootClassName='key-benefitsroot-class-name' />
      <CTA />
      <Stepss />
      <DocumentationServiceOverview />
      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
